import FacilityNew from './FacilityNew'

export default FacilityNew;